import React from 'react';
import { GlassCard } from './GlassCard';

export interface ModuleHeaderProps {
  title: string;
  breadcrumb?: string[];
  actions?: React.ReactNode[];
  className?: string;
}

export const ModuleHeader: React.FC<ModuleHeaderProps> = ({
  title,
  breadcrumb = [],
  actions = [],
  className = '',
}) => {
  return (
    <GlassCard variant="strong" padding="md" className={`module-header ${className}`}>
      <div style={styles.container}>
        <div style={styles.leftSection}>
          {/* Breadcrumb Trail */}
          {breadcrumb.length > 0 && (
            <nav style={styles.breadcrumb} aria-label="Breadcrumb">
              {breadcrumb.map((item, index) => (
                <React.Fragment key={index}>
                  <span
                    style={{
                      ...styles.breadcrumbItem,
                      ...(index === breadcrumb.length - 1 ? styles.breadcrumbActive : {}),
                    }}
                  >
                    {item}
                  </span>
                  {index < breadcrumb.length - 1 && (
                    <span style={styles.breadcrumbSeparator}>·</span>
                  )}
                </React.Fragment>
              ))}
            </nav>
          )}
          
          {/* Page Title */}
          <h1 style={styles.title}>{title}</h1>
        </div>

        {/* Action Buttons */}
        {actions.length > 0 && (
          <div style={styles.actions}>
            {actions.map((action, index) => (
              <div key={index} style={styles.actionWrapper}>
                {action}
              </div>
            ))}
          </div>
        )}
      </div>
    </GlassCard>
  );
};

const styles: Record<string, React.CSSProperties> = {
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 'var(--space-4)',
  },
  leftSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: 'var(--space-1)',
  },
  breadcrumb: {
    display: 'flex',
    alignItems: 'center',
    gap: 'var(--space-2)',
    fontSize: 'var(--text-sm)',
    color: 'var(--text-secondary)',
  },
  breadcrumbItem: {
    transition: 'color var(--transition-fast)',
  },
  breadcrumbActive: {
    color: 'var(--text)',
    fontWeight: 'var(--font-medium)',
  },
  breadcrumbSeparator: {
    color: 'var(--text-muted)',
    margin: '0 var(--space-1)',
  },
  title: {
    fontSize: 'var(--text-2xl)',
    fontWeight: 'var(--font-light)',
    color: 'var(--text)',
    margin: 0,
    lineHeight: 'var(--leading-tight)',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    gap: 'var(--space-3)',
    flexWrap: 'wrap',
  },
  actionWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
};

export default ModuleHeader;
